"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("../datapoints");
var owa_mail_list_actions_1 = require("owa-mail-list-actions");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_table_loading_actions_1 = require("owa-mail-table-loading-actions");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var selectSortInternal = legacy_1.action('selectSortInternal', datapoints_1.default.selectSort)(function selectSortInternal(sortColumnToSelect, sortDirectionToSelect, tableView, actionSource) {
    var sortBy = {
        sortColumn: sortColumnToSelect,
        sortDirection: sortDirectionToSelect,
    };
    var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(tableView.tableQuery.folderId, tableView.tableQuery.listViewType, owa_mail_list_store_1.getFocusedFilterForTable(tableView), 'All', null /* categoryName */, // Support sort - VSO: 23489 - Category Filter Drop down menu to show in category list view and category search
    sortBy // sortBy selected by the user
    );
    return owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery);
});
/**
 * Selects the sort on the current selected table
 * @param sortColumn selected by the user
 * @param tableViewId table view id
 * @param actionSource source of this action
 */
exports.default = legacy_1.action('selectSort')(function selectSort(sortColumn, tableViewId, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var currentSortBy = tableView.tableQuery.sortBy;
    var isSameSortColumnSelected = currentSortBy.sortColumn == sortColumn;
    var sortDirectionToSelect;
    if (isSameSortColumnSelected) {
        // If same sort is selected then toggle the sort direction and load the table
        sortDirectionToSelect =
            currentSortBy.sortDirection == owa_mail_list_store_1.MailSortHelper.ASCENDING_SORT_DIR
                ? owa_mail_list_store_1.MailSortHelper.DESCENDING_SORT_DIR
                : owa_mail_list_store_1.MailSortHelper.ASCENDING_SORT_DIR;
    }
    else {
        // If different sort is selected then get the default sort direction for this sort column
        sortDirectionToSelect = owa_mail_list_store_1.MailSortHelper.getDefaulSortDirectionForSortColumn(sortColumn);
    }
    selectSortInternal(sortColumn, sortDirectionToSelect, tableView, actionSource);
    undoActions.clearLastUndoableAction();
});
//# sourceMappingURL=selectSort.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-filter-actions/lib/actions/selectSort.js
// module id = 2324
// module chunks = 46 105